var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 64",
    width: 140,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blue-outline-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f7e5b9 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m101.5 43.7c-0.2 0-0.3 0.1-0.5 0.1q-0.2 0-0.4 0-0.4-0.2-0.8-0.2c-0.2 0-2.4-0.4-2.4 0.1 0 0.1 0.4 0.1 0.4 0.1q0.9 0.4 2 0.4c0.4-0.1 0.8-0.2 1.3-0.3 0.1 0 0.3-0.2 0.4-0.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m101.6 42.5c-0.1-0.1-0.3 0-0.5 0q-0.2 0-0.4 0-0.4-0.1-0.9-0.2c-0.1 0-2.5-0.3-2.5 0.1 0 0.1 0.4 0.1 0.4 0.1q1 0.4 2.1 0.4c0.5-0.1 0.9-0.2 1.3-0.3 0.2 0 0.4-0.2 0.5-0.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m101.8 41.2c-0.2-0.1-0.4 0-0.5 0q-0.3 0-0.5 0-0.5-0.1-0.9-0.1c-0.2 0-2.6-0.4-2.6 0 0 0.1 0.4 0.1 0.4 0.1q1 0.4 2.1 0.4c0.5-0.1 1-0.2 1.5-0.2 0.1 0 0.3-0.2 0.4-0.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m101.9 39.9c-0.2-0.1-0.3 0.1-0.5 0.1q-0.3 0-0.5-0.1-0.5-0.1-1-0.1c-0.1 0-2.7-0.4-2.7 0 0 0.1 0.4 0.1 0.4 0.1q1.1 0.4 2.3 0.4c0.5-0.1 1-0.1 1.5-0.2 0.2 0 0.3-0.2 0.5-0.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m102 38.6c-0.1-0.1-0.3 0.1-0.5 0.1q-0.2 0-0.5-0.1-0.5-0.1-1-0.1c-0.1 0-2.8-0.4-2.8 0 0 0.1 0.4 0.1 0.4 0.1q1.2 0.4 2.4 0.4c0.5-0.1 1-0.1 1.5-0.2 0.2 0 0.4-0.2 0.6-0.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m122.6 44.5c0.1-0.2-0.1-0.4-0.1-0.6q0-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.3-3.5 0-3.5-0.1 0-0.1 0.5-0.2 0.5q-0.4 1.5-0.4 3c0.2 0.7 0.3 1.2 0.4 1.9 0 0.2 0.2 0.4 0.2 0.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m123.9 44.5c0.1-0.2-0.1-0.4-0.1-0.6q0-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.3-3.5 0-3.5-0.1 0-0.1 0.5-0.2 0.5q-0.4 1.5-0.4 3c0.2 0.7 0.2 1.2 0.4 1.9 0 0.2 0.2 0.4 0.2 0.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m125.2 44.5c0-0.2-0.1-0.4-0.2-0.6q0-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.4 1.5-0.4 3c0.1 0.7 0.2 1.2 0.3 1.9 0 0.2 0.3 0.4 0.2 0.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m126.5 44.5c0.1-0.2-0.1-0.4-0.1-0.6q-0.1-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.3-3.5 0-3.5-0.1 0-0.2 0.5-0.2 0.5q-0.4 1.5-0.4 3c0.2 0.7 0.2 1.2 0.4 1.9 0 0.2 0.2 0.4 0.1 0.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m127.8 44.5c0-0.2-0.1-0.4-0.1-0.6q-0.1-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.3-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.5 1.5-0.5 3c0.2 0.7 0.3 1.2 0.4 1.9 0 0.2 0.2 0.4 0.2 0.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m71.3 43c-0.1 0-0.3 0.1-0.4 0.1q-0.2 0-0.4 0-0.5-0.2-0.9-0.2c-0.1 0-2.3-0.4-2.3 0.1 0 0 0.3 0.1 0.3 0.1q1 0.4 2 0.4c0.5-0.1 0.9-0.2 1.3-0.3 0.2 0 0.3-0.2 0.4-0.1v-0.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m71.5 41.8c-0.1-0.1-0.3 0-0.5 0q-0.2 0-0.4 0-0.4-0.2-0.9-0.2c-0.1 0-2.5-0.4-2.5 0 0 0.1 0.4 0.1 0.4 0.1q1 0.4 2.1 0.4c0.4-0.1 0.9-0.1 1.3-0.2 0.2 0 0.3-0.2 0.5-0.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m71.6 40.5c-0.2-0.1-0.3 0-0.5 0q-0.2 0-0.4 0-0.5-0.1-1-0.2c-0.2 0-2.6-0.3-2.6 0.1 0 0.1 0.4 0.1 0.4 0.1q1 0.4 2.2 0.4c0.4-0.1 0.9-0.2 1.4-0.3 0.1 0 0.3-0.1 0.4-0.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m71.7 39.2c-0.1-0.1-0.3 0.1-0.5 0.1q-0.2-0.1-0.4-0.1-0.5-0.1-1-0.1c-0.2 0-2.8-0.4-2.8 0 0 0.1 0.5 0.1 0.5 0.1q1.1 0.4 2.3 0.4c0.5-0.1 0.9-0.2 1.4-0.2 0.2 0 0.4-0.2 0.5-0.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m46.7 44.3c0-0.2-0.1-0.4-0.2-0.6q0-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.4 1.4-0.4 3c0.1 0.6 0.2 1.2 0.3 1.9 0 0.2 0.3 0.4 0.2 0.6h0.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m48 44.3c0-0.2-0.1-0.4-0.1-0.6q-0.1-0.3 0-0.6 0.1-0.7 0-1.3c0-0.2 0.4-3.5 0-3.5 0 0-0.1 0.5-0.1 0.5q-0.4 1.4-0.4 3c0.2 0.6 0.2 1.2 0.4 1.9 0 0.2 0.2 0.4 0.1 0.6h0.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m49.3 44.3c0-0.2-0.1-0.4-0.1-0.6q-0.1-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.3-3.5 0-3.5-0.1 0-0.2 0.5-0.2 0.5q-0.4 1.4-0.4 3c0.2 0.6 0.2 1.2 0.4 1.9 0 0.2 0.2 0.4 0.1 0.6h0.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m50.6 44.3c0-0.2-0.1-0.4-0.1-0.6q-0.1-0.3 0-0.6 0-0.7 0-1.3c0-0.2 0.4-3.5 0-3.5 0 0-0.1 0.5-0.1 0.5q-0.4 1.4-0.4 3c0.1 0.6 0.2 1.2 0.4 1.9 0 0.2 0.2 0.4 0.1 0.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m51.9 44.3c0-0.2-0.1-0.4-0.1-0.6q-0.1-0.3 0-0.6 0.1-0.7 0.1-1.3c0-0.2 0.3-3.5 0-3.5-0.1 0-0.2 0.5-0.2 0.5q-0.4 1.4-0.4 3c0.2 0.6 0.2 1.2 0.4 1.9 0 0.2 0.2 0.4 0.1 0.6h0.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m88.6 15v29.6c0 0.4-0.1 0.6-0.5 0.6h-0.9c-0.4 0-0.5-0.2-0.5-0.6v-19.8c0-2.3 0.1-4.7 0.3-7.3h-0.1c-6.9 5.3-11.2 9-11.2 9-0.2 0.2-0.2 0.2-0.4 0.2h-0.7q-0.3 0-0.5-0.2c0 0-8.4-6.8-11.2-9h-0.1c0.2 2.6 0.3 4.9 0.3 7.2v19.9c0 0.4-0.1 0.6-0.6 0.6h-0.7c-0.5 0-0.6-0.2-0.6-0.6v-29.6c0-0.4 0.1-0.5 0.6-0.5h0.6q0.3-0.1 0.5 0.1 0.3 0.1 0.4 0.3l11.6 10.9 11.6-10.9c0.2-0.3 0.3-0.5 0.7-0.5h0.9c0.4 0.1 0.5 0.2 0.5 0.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m63 44.8l-12-29.9q-0.1-0.3-0.3-0.4-0.2-0.2-0.4-0.1h-0.9q-0.3-0.1-0.5 0.1-0.2 0.1-0.3 0.4l-12 29.9c-0.1 0.3 0 0.5 0.4 0.5h0.7c0.7 0 0.9-0.1 1-0.5l3.8-9.6 7.2-18.9h0.2l7.1 18.9 3.8 9.6c0.1 0.4 0.3 0.5 1 0.5h0.8c0.5 0 0.6-0.2 0.4-0.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m113.5 44.7l-12.1-29.9q0-0.2-0.2-0.4-0.2-0.1-0.5-0.1h-0.9c-0.4 0-0.5 0.1-0.7 0.5l-12 29.9c-0.2 0.3 0 0.5 0.4 0.5h0.7c0.6 0 0.9-0.1 1-0.5l3.8-9.5 7.2-18.9h0.2l7 18.9 3.9 9.5c0.1 0.4 0.3 0.5 1 0.5h0.8c0.4 0 0.5-0.2 0.4-0.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m138.4 44.7l-12.1-29.9q0-0.2-0.2-0.4-0.2-0.1-0.5-0.1h-0.9c-0.4 0-0.5 0.1-0.7 0.5l-12 29.9c-0.2 0.3 0 0.5 0.3 0.5h0.8c0.6 0 0.9-0.1 1-0.5l3.8-9.5 7.2-18.9h0.2l7 18.9 3.9 9.5c0.1 0.4 0.3 0.5 1 0.5h0.8c0.4 0 0.5-0.2 0.4-0.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m14.9 44c6.3 0 9.4-3.6 9.4-9.2v-19.8c0-0.4 0.1-0.6 0.5-0.6h1c0.4 0 0.5 0.2 0.5 0.6v19.8c0 6.7-3.8 11-11.4 11-7.6 0-11.5-4.3-11.5-11v-19.8c0-0.4 0.2-0.6 0.6-0.6h0.9c0.4 0 0.5 0.2 0.5 0.6v19.8c0 5.6 3 9.2 9.5 9.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m38.4 25.2v17.4c0 6.2-3.1 10.1-8.9 10.1-5.2 0-7.9-3.2-8.8-8.5-0.2-0.4 0-0.6 0.3-0.8l0.7-0.3q0.5-0.2 0.6 0.4c0.8 4.6 2.8 7.3 7.2 7.3 4.7 0 7.2-3.1 7.2-8.2v-17.4c0-0.4 0.1-0.6 0.4-0.6h0.9c0.3 0 0.4 0.2 0.4 0.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m77.8 43.6c0.1-0.2-0.1-0.4-0.1-0.7q0-0.3 0-0.6 0.1-0.6 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.5 1.5-0.4 3c0.1 0.7 0.2 1.3 0.3 1.9 0 0.3 0.2 0.5 0.2 0.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m79.1 43.6c0.1-0.2-0.1-0.4-0.1-0.7q0-0.3 0-0.6 0.1-0.6 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.5 1.5-0.4 3c0.1 0.7 0.2 1.3 0.3 1.9 0 0.3 0.3 0.5 0.2 0.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m80.4 43.6c0.1-0.2-0.1-0.4-0.1-0.7q0-0.3 0-0.6 0.1-0.6 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.5 1.5-0.4 3c0.1 0.7 0.2 1.3 0.3 1.9 0 0.3 0.3 0.5 0.2 0.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m81.7 43.6c0.1-0.2-0.1-0.4-0.1-0.7q0-0.3 0-0.6 0.1-0.6 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.5 1.5-0.4 3c0.1 0.7 0.2 1.3 0.3 1.9 0 0.3 0.2 0.5 0.2 0.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m83 43.6c0.1-0.2-0.1-0.4-0.1-0.7q0-0.3 0-0.6 0.1-0.6 0.1-1.3c0-0.2 0.4-3.5 0-3.5-0.1 0-0.1 0.5-0.1 0.5q-0.5 1.5-0.4 3c0.1 0.7 0.2 1.3 0.3 1.9 0 0.3 0.2 0.5 0.2 0.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m71.9 37.9c-0.2-0.1-0.4 0.1-0.5 0.1q-0.3 0-0.5-0.1-0.6-0.1-1.1-0.1c-0.1 0-2.8-0.4-2.8 0 0 0.1 0.4 0.1 0.4 0.1q1.2 0.4 2.4 0.4c0.5-0.1 1-0.1 1.6-0.2 0.1 0 0.3-0.2 0.5-0.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m38.8 21.3c-0.2 0.1-0.2 0.3-0.4 0.4q-0.2 0.2-0.4 0.3-0.5 0.3-0.9 0.6c-0.1 0.1-2.7 1.2-2.5 1.5 0 0.1 0.4-0.1 0.5-0.1q1.2-0.2 2.3-1c0.4-0.4 0.7-0.8 1.1-1.2 0.1-0.1 0.1-0.4 0.3-0.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m38 20.3c-0.2 0-0.2 0.3-0.4 0.4q-0.1 0.2-0.4 0.3-0.4 0.2-0.9 0.5c-0.1 0.1-2.5 1.2-2.3 1.5 0 0.1 0.4-0.1 0.4-0.1 0.8-0.2 1.6-0.5 2.3-1 0.3-0.4 0.7-0.7 1-1.1 0.1-0.2 0.1-0.4 0.3-0.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m37.2 19.3c-0.2 0-0.2 0.2-0.3 0.4q-0.2 0.1-0.4 0.2-0.5 0.2-0.9 0.5c-0.1 0.1-2.4 1.1-2.3 1.5 0 0 0.4-0.1 0.5-0.1 0.7-0.2 1.5-0.5 2.1-0.9 0.4-0.4 0.7-0.7 1-1.2 0.1-0.1 0.1-0.3 0.3-0.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m36.4 18.3c-0.2 0-0.2 0.2-0.3 0.3q-0.2 0.2-0.4 0.3-0.4 0.2-0.8 0.5c-0.1 0.1-2.4 1-2.2 1.3 0 0.1 0.4-0.1 0.4-0.1 0.8-0.1 1.5-0.3 2.1-0.8 0.3-0.4 0.6-0.7 1-1.1 0.1-0.1 0.1-0.4 0.3-0.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m35.6 17.2c-0.2 0-0.2 0.3-0.3 0.4q-0.2 0.1-0.4 0.2-0.4 0.2-0.8 0.5c0 0.1-2.2 1-2 1.3 0 0.1 0.3-0.1 0.4-0.1 0.7-0.1 1.4-0.3 2-0.7 0.3-0.4 0.6-0.7 0.9-1.1 0.1-0.1 0.1-0.4 0.2-0.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOutline);
export default __webpack_public_path__ + "static/media/blue-outline.24ffe2abaf187b695f260d0b80136f0a.svg";
export { ForwardRef as ReactComponent };